export default {
  colors: {
    primary: {
      darkest: '#651410',
      dark: '#A01512',
      main: '#E42621',
      light: '#E63732',
      lighest: '#ED625F',
    },
    secondary: {
      darkest: '#482501',
      dark: '#A5430E',
      main: '#E04F14',
      light: '#EC642C',
      lighest: '#F1865A',
    },
    outher: {
      success: '#48D904',
      danger: '#FF0004',
      attencion: '#FFAA00',
    },
    gradient: {
      fullX: 'linear-gradient(90deg, #66140E 0%, #E42320 48%, #E04E11 100%);',
      fullY: 'linear-gradient(180deg, #66140E 0%, #E42320 48%, #E04E11 100%);',
      180: 'linear-gradient(180deg, #040505 20%, #651410 90%, #E42621 110%)',
      0: 'linear-gradient(0deg, #040505 20%, #651410 90%, #E42621 110%)',
    },
    grey: {
      black: '#000000',
      800: '#040505',
      700: '#0D0D0D',
      600: '#141414',
      500: '#6B6B6B',
      200: '#C1C1C1',
      100: '#F9F9F9',
      white: '#FFFFFF',
    },
  },
  devices: {
    mobile: '(max-width: 480px)',
    tablet: '(max-width: 768px)',
    notebook: '(max-width: 1200px)',
  },
};
